<mat-toolbar color="accent">View ACC Claim Documents</mat-toolbar>

<div class="flex min-h-[80vh] flex-col p-4">
  <mat-tab-group class="flex-1">
    @for (document of documents$ | async; track document.url) {
      <mat-tab [label]="document.label">
        <object
          type="application/pdf"
          width="100%"
          height="100%"
          [data]="document.url"
        >
          <p>
            Your browser does not support PDF embedding.<br />
            Please download the PDF to view it:
            <a target="_blank" [href]="document.url">Download PDF</a>
          </p>
        </object>
      </mat-tab>
    } @empty {
      <pr-empty-state image="list" description="documents found" />
    }
  </mat-tab-group>
</div>
